import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, GetLoginCredentialDb, getModValue, linksUrl } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faPlus,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/productionSlice"

const ProductionEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { token, user } = useSelector((state) => state.auth)
  const { compCode, isMultipleCompany, yearId } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetDetailParams())
  }, [])

  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.production.fetch,
    queryKey: "Production Data List",

  })
  const funFilterData = () => {
    filterData({
      data: {
        compcode: compCode.join(","),
      }
    })

  }

  useEffect(() => {
    funFilterData();
  }, [])



  const onSuccessDelete = (data) => {
    setItemToDelete("")
    
    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Entry can't be delete as one/more taka of this challan are in used/delivered ", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData();
      }

    }
  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.production.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalTAKA = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "taka",
      }),
    [data]
  )
  let totalMeter = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "meter",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "chal_no",
    "party",
    "taka",
    "meter",
    "chal_date"


  ]
  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "CHAL NO",
      uid: "chal_no",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Unit A\C ID",
      uid: "party",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.left
    },
    {
      name: "TAKA",
      uid: "taka",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTAKA,
      },
    },
    {
      name: "METER",
      uid: "meter",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalMeter,
      },
    },
    {
      name: "DATE",
      uid: "chal_date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    }


  ]
  const exportColumns = [

    {
      name: "CHAL NO",
      uid: "chal_no",
    },
    {
      name: "Unit A\C ID",
      uid: "party",
    },
    {
      name: "TAKA",
      uid: "taka",
    },
    {
      name: "DATE",
      uid: "chal_date",
      type:COLUMN_TYPE.date
    },
    {
      name: "METER",
      uid: "meter",
    },
    
  ]

  let downloadDataFooter = {
    party: "",
    chal_no: "",
    taka: " Total:" + totalTAKA,
    chal_date: "",
    meter: " Total:" + totalMeter,
   
  }

  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const handleConfirmBox = (data) => {
    if (data) {

      FndeleteNote({
        data: {
          rp_id: itemToDelete.rp_id,
          comp_code: itemToDelete.comp_code,
          chal_no: itemToDelete.chal_no,
        }
      })
    }
    else {
      setItemToDelete("")
    }

  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        let obj = {
          comp_code: compCode.join(","),
          chal_no: row.chal_no,
          rp_id: row.rp_id,
        }
        disapatch(setDetailParams(obj))
        disapatch(setNewEntryMode(false))
        navigate(linksUrl.production.createProdcutionEntry)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {

        setItemToDelete({ comp_code: compCode.join(","), rp_id: row.rp_id, chal_no: row.chal_no })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    navigate(linksUrl.production.createProdcutionEntry)
  }



  return (
    <div>

      {itemToDelete != "" ? <ConfirmBox handleConfirmBox={handleConfirmBox} /> : ""}

      <MainContainer
        pageName="Productions"
        info={[]}
        breadcrumbs={["Transaction", "Gray Production"]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          downloadFileName="ProductionData-List"
          id="chal_no"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default ProductionEntryMaster
